import * as rulesV2 from './static-data/rules-data-v2';
import { RULES_DATA, RulesDataModule } from './rules-data.token';

export const RULES_DATA_PROVIDER = {
  provide: RULES_DATA,
  useValue: rulesV2,
};
